import { BookOpen, Rocket, HelpCircle, Shield } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { ManualChapterViewer } from '@/features/help-center/components/manual-chapter-viewer';
import { QuickStartGuide } from '@/features/help-center/components/quick-start-guide';
import { FaqSection } from '@/features/help-center/components/faq-section';
import { SlaSection } from '@/features/help-center/components/sla-section';
import { DocsLayout } from '../components/docs-layout';

export function HelpPage() {
  return (
    <DocsLayout
      title="Centro de Ayuda"
      description="Todo lo que necesitas para usar Prixia de manera efectiva."
    >
      <Tabs defaultValue="manual">
        <TabsList className="w-full justify-start overflow-x-auto">
          <TabsTrigger value="manual" className="gap-1.5">
            <BookOpen className="h-4 w-4" />
            <span className="hidden sm:inline">Manual</span>
          </TabsTrigger>
          <TabsTrigger value="quick-start" className="gap-1.5">
            <Rocket className="h-4 w-4" />
            <span className="hidden sm:inline">Inicio Rapido</span>
          </TabsTrigger>
          <TabsTrigger value="faq" className="gap-1.5">
            <HelpCircle className="h-4 w-4" />
            <span className="hidden sm:inline">Preguntas Frecuentes</span>
          </TabsTrigger>
          <TabsTrigger value="sla" className="gap-1.5">
            <Shield className="h-4 w-4" />
            <span className="hidden sm:inline">SLA</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="manual" className="mt-6">
          <ManualChapterViewer />
        </TabsContent>

        <TabsContent value="quick-start" className="mt-6">
          <QuickStartGuide />
        </TabsContent>

        <TabsContent value="faq" className="mt-6">
          <FaqSection />
        </TabsContent>

        <TabsContent value="sla" className="mt-6">
          <SlaSection />
        </TabsContent>
      </Tabs>
    </DocsLayout>
  );
}
